export function formatDuration(minutes: number): string {
  if (minutes < 60) return `${minutes} min`;
  const h = Math.floor(minutes / 60);
  const m = minutes % 60;
  return m > 0 ? `${h}h ${m}m` : `${h}h`;
}

export function sumPlannedMinutes(
  topics: { durationMinutes: number | null | undefined }[],
): number {
  return topics.reduce(
    (sum, t) => sum + (t.durationMinutes != null && t.durationMinutes > 0 ? t.durationMinutes : 0),
    0,
  );
}

export function formatTotalDuration(minutes: number): string {
  const h = Math.floor(minutes / 60);
  const m = minutes % 60;
  if (h === 0) return `${m}m`;
  if (m === 0) return `${h}h`;
  return `${h}h ${m}m`;
}
